import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFileArrowRightIn: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="file-arrow-right-in, document-arrow-right-in, incoming"><path d="M19.25 13.25V9.25L12.75 2.75H4.75V21.25H9.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M12.75 3.25439V9.24982H18.7501" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><path d="M14 19H20.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M15.75 16L12.75 19L15.75 22" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconFileArrowRightIn;
